import { default as indexM2GN6V3VNhMeta } from "/codebuild/output/src4255038753/src/src/pages/[companySlug]/faq/[id]/index.vue?macro=true";
import { default as indexT6iyaQ3iZCMeta } from "/codebuild/output/src4255038753/src/src/pages/[companySlug]/important-news/index.vue?macro=true";
import { default as indext51OSaa2NAMeta } from "/codebuild/output/src4255038753/src/src/pages/[companySlug]/index.vue?macro=true";
import { default as indexuK5ixcBkUfMeta } from "/codebuild/output/src4255038753/src/src/pages/[companySlug]/news/[id]/index.vue?macro=true";
import { default as indexAgConWQl4PMeta } from "/codebuild/output/src4255038753/src/src/pages/[companySlug]/news/index.vue?macro=true";
import { default as indexgQNMvhHjV7Meta } from "/codebuild/output/src4255038753/src/src/pages/[companySlug]/preview/faq/index.vue?macro=true";
import { default as indexKMjIfqzeyzMeta } from "/codebuild/output/src4255038753/src/src/pages/[companySlug]/preview/news/index.vue?macro=true";
export default [
  {
    name: "companySlug-faq-id",
    path: "/:companySlug()/faq/:id()",
    component: () => import("/codebuild/output/src4255038753/src/src/pages/[companySlug]/faq/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "companySlug-important-news",
    path: "/:companySlug()/important-news",
    component: () => import("/codebuild/output/src4255038753/src/src/pages/[companySlug]/important-news/index.vue").then(m => m.default || m)
  },
  {
    name: "companySlug",
    path: "/:companySlug()",
    component: () => import("/codebuild/output/src4255038753/src/src/pages/[companySlug]/index.vue").then(m => m.default || m)
  },
  {
    name: "companySlug-news-id",
    path: "/:companySlug()/news/:id()",
    component: () => import("/codebuild/output/src4255038753/src/src/pages/[companySlug]/news/[id]/index.vue").then(m => m.default || m)
  },
  {
    name: "companySlug-news",
    path: "/:companySlug()/news",
    component: () => import("/codebuild/output/src4255038753/src/src/pages/[companySlug]/news/index.vue").then(m => m.default || m)
  },
  {
    name: "companySlug-preview-faq",
    path: "/:companySlug()/preview/faq",
    component: () => import("/codebuild/output/src4255038753/src/src/pages/[companySlug]/preview/faq/index.vue").then(m => m.default || m)
  },
  {
    name: "companySlug-preview-news",
    path: "/:companySlug()/preview/news",
    component: () => import("/codebuild/output/src4255038753/src/src/pages/[companySlug]/preview/news/index.vue").then(m => m.default || m)
  }
]